export enum featureFlagKeys {
	AccountBalance = '_checkout__account_balance_countries',
	BestSellerTag = 'show_pdp_tag_bestseller',
	Chatbot = 'chatbot_toggle',
	CIAM = 'all_ciam',
	CookiesBanner = 'cookies_banner',
	CountryLanguage = 'all_country_language',
	Dam = 'dam',
	Discover = 'rollout_discover_by_mango',
	EditorialsSS25KaiaSecondphase = 'editorials_SS25_kaia_secondphase',
	EditorialsSS25KaiaNoCapsule = 'editorials_SS25_kaia_nocapsule',
	EnableDigitalReturns = 'enable_digital_returns',
	GenesisGiftVoucher = 'gift_voucher_genesis',
	GenesisPdp = 'pdp_genesis_activation',
	GenesisServerCache = 'genesis_server_cache',
	Header_black_ribbon = 'header_black_ribbon',
	HelpPage = 'page_help',
	HomeA11yHiddenLink = 'homes_a11y_hidden_link',
	/** Used in homepages to enable or disable an specific brand (included multibrand) */
	HomesEnableGiftVoucher = 'homes_enable_gift_voucher',
	HomesLinkToFashionAssistant = 'homes_link_to_fashion_assistant',
	LabelsTranslations = 'labels_translations',
	MangoLikesYouClubTiers = 'mango_likes_you_club_tiers',
	MangoStyleClub = 'mango_style_club',
	MapsDistanceInMiles = 'maps_distance_in_miles',
	MyBalancePage = 'page_my_balance',
	MyPurchasesShow = 'mypurchases_show',
	MyRefundsPage = 'page_my_refunds',
	NewSearch = 'new_search',
	NewsletterConfiguration = 'newsletter_configuration',
	NonCriticalFeatures = 'non-critical_features',
	OmnibusExceptionCountries = 'price_omnibus_countries',
	OrderCancellation = 'mypurchases_cancel_order',
	PaymentStoredCards = 'payments_stored_cards',
	PdpLongAiDescription = 'pdp_long_ai_description',
	PlpBannersVasava = '_plp__banners__vasava_active',
	PlpBestSellers = 'plp_bestsellers',
	PlpSegmentation = 'plp_genesis_segmentation',
	PlpVersion = '_plp__genesis__activation_versions',
	PrivacyPolicyConfiguration = 'privacy_policy_configuration',
	PrivacyPolicyRequestForm = 'privacy_policy_request_form',
	ProductCardOverlayLabel = 'productcard_overlay_label',
	ProductCarousel = 'shopping_cart_product_carousel',
	PromoBanner = 'promo_countdown',
	PurchaseEventInBack = '_checkout__purchase_event_in_back',
	RegistryPostalCode = 'registry_postal_code',
	ReturnHasCost = 'return_has_cost_since_date',
	ReturnsDisableDroppointMethod = 'returns_disable_droppoint_method',
	ReturnsFeedback = 'enable_returns_feedback',
	SecondReturnsBlock = 'block_second_returns',
	ShoppingCartRecommendationXselling = 'shopping_cart_recommendation_xselling',
	ShowDiscount = 'price_show_discount',
	ShowSavedPrice = 'cart_show_saved_price',
	Storage = 'storage',
	PlpConfig = 'plp_config',
	RecoveryPasswordActivated = 'login_activate_forgot_password_genesis',
	PaymentEnablePaymentMethod = 'payment_enable_payment_method',
	PageActivation = 'page_activation',
	PaymentsApplePayNewIntegration = 'payments_applepay_new_integration',
	MyPurchasesContextualizedHelp = 'mypurchases_contextualized_help',
	MyPurchasesReturns = 'mypurchases_returns',
	PaymentsInlineCardIcons = 'payments_inline_card_icons',
	ShoppingCartConfig = 'shopping_cart_config',
	Varnish = 'varnish',
}

export type NonCriticalFeaturesVariables = {
	favorites: boolean
	multiaddress: boolean
	my_purchases: boolean
	order_status_banner: boolean
	personalization_cart: boolean
	personalization_pdp: boolean
	personalization_plp: boolean
	personalization_search: boolean
}
